import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import LanguageContext from '../LanguageContext';

function Footer() {
  const { language, selectedLanguage } = useContext(LanguageContext);
  const shellStripStyle = {
    '--app-shell-strip-image': `url(${process.env.PUBLIC_URL || ''}/Headerfooter_strip_Create_a_thin_decorative_horizontal_band_for_a_website_head_20260316173810_02.png)`
  };

  const text = {
    en: {
      supportLinks: 'Support information',
      help: 'Help and support',
      accessibility: 'Accessibility',
      cookies: 'Cookies',
      privacy: 'Privacy'
    },
    fr: {
      supportLinks: 'Information de soutien',
      help: 'Aide et soutien',
      accessibility: 'Accessibilité',
      cookies: 'Cookies',
      privacy: 'Confidentialité'
    }
  };
  const uiLanguage = text[selectedLanguage] ? selectedLanguage : language;

  return (
    <>
      <div
        className="app-shell-strip app-footer-strip"
        aria-hidden="true"
        style={shellStripStyle}
      />
      <footer className="govuk-footer" role="contentinfo">
      <div className="govuk-width-container">
        <div className="govuk-footer__meta">
          <div className="govuk-footer__meta-item govuk-footer__meta-item--grow">
            <h2 className="govuk-visually-hidden">{text[uiLanguage].supportLinks}</h2>
            <ul className="govuk-footer__inline-list">
              <li className="govuk-footer__inline-list-item">
                <Link to="/help" className="govuk-footer__link">{text[uiLanguage].help}</Link>
              </li>
              <li className="govuk-footer__inline-list-item">
                <Link to="/accessibility" className="govuk-footer__link">{text[uiLanguage].accessibility}</Link>
              </li>
              <li className="govuk-footer__inline-list-item">
                <Link to="/cookies" className="govuk-footer__link">{text[uiLanguage].cookies}</Link>
              </li>
              <li className="govuk-footer__inline-list-item">
                <Link to="/privacy" className="govuk-footer__link">{text[uiLanguage].privacy}</Link>
              </li>
            </ul>
          </div>
          <div className="govuk-footer__meta-item govuk-footer__meta-item--logo">
            <Link to="/about">
              <img src="/NWAC_logo.png" alt="NWAC logo" width="50" height="50" />
            </Link>
          </div>
        </div>
      </div>
      </footer>
    </>
  );
}

export default Footer;
